export default __webpack_public_path__ + "static/media/21.80a8a912.jpg";